/**
 * Auth Service - аутентификация и авторизация
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";
import { browserName, osName } from "react-device-detect";

// Получить IP (для логина)
const getIp = async () => {
    try {
        const data = await apiClient.get(
            "https://api.ipify.org?format=json",
            {},
            false,
        );
        return data?.ip || "unknown";
    } catch {
        return "unknown";
    }
};

export const authService = {
    /**
     * Логин пользователя
     */
    login: async (login, password) => {
        const ip = await getIp();
        const data = {
            login,
            password,
            ip,
            client: browserName,
            platform: osName,
        };
        return apiClient.postPublic(ENDPOINTS.AUTH.LOGIN, data);
    },

    /**
     * Подтверждение 2FA (legacy gauth)
     */
    confirmAuth: async ({
        user_name,
        user_password,
        ip,
        client,
        platform,
        verification_code,
    }) => {
        return apiClient.postPublic(ENDPOINTS.AUTH.CONFIRM_AUTH, {
            user_name,
            user_password,
            ip,
            client,
            platform,
            verification_code,
        });
    },

    /**
     * Проверка 2FA кода
     */
    checkTwoFactor: async (code) => {
        return apiClient.post(
            ENDPOINTS.TWO_FACTOR.CHECK,
            { code },
            true,
            false,
        );
    },

    /**
     * Настройка 2FA
     */
    setupTwoFactor: async () => {
        return apiClient.get(ENDPOINTS.TWO_FACTOR.SETUP, {}, true);
    },

    /**
     * Получить IP клиента
     */
    getIp: getIp,

    /**
     * Сохранение данных пользователя после логина
     */
    saveUserData: (data) => {
        if (data.jwt) {
            localStorage.setItem("jwtToken", data.jwt);
        }
        if (data.player) {
            localStorage.setItem("user-id", data.player.id);
            localStorage.setItem("user-login", data.player.login);
            localStorage.setItem("user-password", data.player.password);
            localStorage.setItem("user-email", data.player.email);
        }
    },

    /**
     * Очистка данных пользователя (логаут)
     */
    clearUserData: () => {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("user-id");
        localStorage.removeItem("user-login");
        localStorage.removeItem("user-password");
        localStorage.removeItem("user-email");
    },

    /**
     * Проверка авторизации
     */
    isAuthenticated: () => {
        return !!localStorage.getItem("jwtToken");
    },

    /**
     * Получить текущего пользователя
     */
    getCurrentUser: () => {
        const id = localStorage.getItem("user-id");
        const login = localStorage.getItem("user-login");
        const email = localStorage.getItem("user-email");

        if (!id) return null;

        return { id, login, email };
    },
};

export default authService;
